import Result from "@/core/common/Result";
import {
  ISalvarAvaliacaoCSATMinhasEmpresasGateway,
  SalvarAvaliacaoMinhasEmpresasParams
} from "../ports/SalvarAvaliacaoCSATMinhasEmpresasGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { ContabilGatewayError } from "@/views/contabil/diagnostico/config/ContabilGatewayError";
import { IDefaultContabilResponse } from "@/services/contabil/types";
import "reflect-metadata";
@injectable()
export class SalvarAvaliacaoCSATMinhasEmpresasGateway
  extends ContabilGatewayError
  implements ISalvarAvaliacaoCSATMinhasEmpresasGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  cliente!: HttpClient;

  async salvar(
    params: SalvarAvaliacaoMinhasEmpresasParams
  ): Promise<Result<void>> {
    try {
      const response = await this.cliente.post<IDefaultContabilResponse<void>>({
        url: "contabil/v1/pesquisa/salvar",
        body: params
      });

      if (this.hasError(response)) {
        return Result.fail("Erro ao salvar a avaliação");
      }

      return Result.ok();
    } catch {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
